import ParameterValidator from '@mvps-genesis/parameter-validator';

/*
 *--------------------------------------------------------------------------
 * Input Value Copy To
 *--------------------------------------------------------------------------
 *
 * Use this extension when you need to programmatically copy the value
 * from one input element to another input element.
 *
 */
export default class InputValueCopyTo {

	/**
	 * Parameter Validator class object
	 *
	 * @var	{ParameterValidator} @mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 * Attribute name for the copy value input elements
	 *
	 * @var {String}
	 */
	copyValueAttribute;

	/**
	 * List of copy value input elements
	 *
	 * @var {NodeList}
	 */
	inputElements;

	/**
	 * Create a InputValueCopyTo instance
	 *
	 * @param  {String} copyValueAttribute  The attribute name to apply to the copy value input elements.
	 */
	constructor (copyValueAttribute = 'data-copy-value-to') {
		this.#validator = new ParameterValidator(this);

		this.copyValueAttribute = this.#validator.isString('copyValueAttribute', copyValueAttribute);
		this.inputElements = this.#validator.isElementList('inputElements', `input[${this.copyValueAttribute}]`);

		this.bindEvents();
	}

	/**
	 * Bind the input element events
	 */
	bindEvents () {
		for (const inputElement of this.inputElements) {
			const copyToInputSelector = inputElement.getAttribute(this.copyValueAttribute);

			if (!copyToInputSelector) {
				continue;
			}

			const copyToInputElement = this.#validator.isElement('bindEvents.copyToInputElement', copyToInputSelector);

			inputElement.addEventListener('input', this.onInput.bind(this, copyToInputElement));
			inputElement.addEventListener('blur', this.onInput.bind(this, copyToInputElement));
		}
	}

	/**
	 * Handle input event
	 *
	 * @param  {HTMLElement} copyToInputElement The target input element for the value to be copied over to
	 * @param  {Event} event                    The source input element event
	 */
	onInput (copyToInputElement, event) {
		const inputElement = event.target;

		copyToInputElement.value = inputElement.value;
	}
}
